import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAsciidoctorComponent } from './simple-icons-asciidoctor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAsciidoctorComponent ],
    exports:      [ SimpleIconsAsciidoctorComponent ],
    bootstrap:    []
})
export class SimpleIconsAsciidoctorModule {}
